var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 52,
    viewBox: "0 0 27 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2596 25.9998L1.02965 4.18227C0.854863 4.00645 0.716677 3.79771 0.623092 3.56813C0.529507 3.33855 0.48238 3.09269 0.48444 2.84477C0.486499 2.59686 0.537702 2.35182 0.635089 2.12383C0.732476 1.89583 0.874112 1.68942 1.0518 1.51652C1.22949 1.34363 1.4397 1.20769 1.67027 1.11658C1.90084 1.02546 2.14719 0.980972 2.39507 0.985691C2.64294 0.990411 2.88742 1.04424 3.11436 1.14407C3.34129 1.2439 3.54617 1.38774 3.71715 1.56727L26.2171 24.6923C26.5577 25.0423 26.7482 25.5114 26.7482 25.9998C26.7482 26.4881 26.5577 26.9572 26.2171 27.3073L3.71715 50.4323C3.54617 50.6118 3.34129 50.7556 3.11436 50.8555C2.88742 50.9553 2.64294 51.0091 2.39507 51.0138C2.14719 51.0186 1.90084 50.9741 1.67027 50.8829C1.4397 50.7918 1.22949 50.6559 1.0518 50.483C0.874112 50.3101 0.732476 50.1037 0.635089 49.8757C0.537702 49.6477 0.486499 49.4027 0.48444 49.1548C0.48238 48.9068 0.529507 48.661 0.623092 48.4314C0.716677 48.2018 0.854863 47.9931 1.02965 47.8173L22.2596 25.9998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.6d7231028ed18c5b63be2529e995cff8.svg";
export { ForwardRef as ReactComponent };